export enum PasswordStatusEnum {
    REQUIRED_CHANGE = "REQUIRED_PASSWORD_CHANGE",
    NOT_REQUIRED_CHANGE = "NOT_REQUIRED_PASSWORD_CHANGE",
}